import {Component, OnInit} from '@angular/core';
import {MenuAsideService} from '../../../../core/_base/layout';
import {ProfileVisitDetailService} from '../../../../provider/profile-visit-detail.service';
import {custom} from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'kt-guest-confirmation',
  templateUrl: './guest-confirmation.component.html',
  styleUrls: ['./guest-confirmation.component.scss']
})
export class GuestConfirmationComponent implements OnInit {

  constructor(public visitService: ProfileVisitDetailService,
              private menuServ: MenuAsideService,
              private http: HttpClient) {
  }

  ngOnInit() {
    this.menuServ.pathname$.next(window.location.pathname);
    this.visitService.getPendingVisit();
  }

  approve(profile_visit_id: number, status: string) {
    const myDialog = custom({
      title: status,
      messageHtml: '<b>Are you sure ?</b>',
      buttons: [{
        text: 'Cancel',
        onClick: (e) => {
          return {buttonText: e.component.option('text')};
        }
      },
        {
          text: 'OK',
          onClick: (e) => {

            this.http.put(environment.baseURL + '/v2/api/profile_visit_set_status',
              {
                status,
                profile_visit_id
              }).subscribe(() => {
                this.visitService.getPendingVisit();
              }, (err) => console.log(err),
              () => {
                notify({
                  message: 'You have ' + status + 'ed',
                  position: {
                    my: 'center top',
                    at: 'center top'
                  }
                }, 'success', 3000);
              });

            return {buttonText: e.component.option('text')};
          }
        }
      ]
    });
    myDialog.show().then();
  }
}
